import React from 'react'
import PropTypes from 'prop-types'
import { Flexbox } from '@/components'

function CardHeader({ icon, title, subtitle }) {
  return (
    <Flexbox.Columns className="align-center">
      {Boolean(icon) && (
        <Flexbox.Column className="col-auto">
          <i className={`${icon} fa-lg`} />
        </Flexbox.Column>
      )}
      <Flexbox.Column>
        <div className="h5">{title}</div>
        {Boolean(subtitle) && <small>{subtitle}</small>}
      </Flexbox.Column>
    </Flexbox.Columns>
  )
}

CardHeader.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
}

CardHeader.defaultProps = {
  icon: '',
  subtitle: null,
}

export default CardHeader
